import { defineType } from "sanity";

export default defineType({
  name: "segmentInfo",
  title: "Segment Info",
  type: "object",
  fields: [
    {
      name: "masterWebCode",
      title: "Master Web Code",
      type: "string",
      readOnly: true
    },
    {
      name: "masterCruiseCode",
      title: "Master Cruise Code",
      type: "string",
      readOnly: true
    },
    {
      name: "position",
      title: "Position",
      description: "Position of this segment within the master voyage",
      type: "string",
      readOnly: true
    }
  ]
});
